import {Container} from "../Core/Container";
import {Package} from "./Package";
import {ShelfItemButton} from "./ShelfItemButton";
import {Overlay} from "./Overlay";
import {HomeScreenModel} from "../Data/HomeScreenModel";
import {HomeScreen} from "../States/HomeScreen";

export abstract class AbstractHomeActivity extends Container {

    protected readonly overlay: Overlay;
    protected readonly screen: HomeScreen;

    constructor(screen: HomeScreen) {
        super();
        this.overlay = screen.overlay;
        this.screen = screen;
    }

    abstract open(box: Package | undefined, button: ShelfItemButton, onClose?: (model?: HomeScreenModel) => void): void;
}